import { useFormContext } from "react-hook-form";
import Table from "../../../../../components/Tables/NonEditableTable";
import PrintToPDF from "./PrintToPDF";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {
  Button,
  MenuItem,
  Select,
  Typography,
  InputLabel,
  FormControl,
  Grid,
  Paper,
  Chip,
  OutlinedInput,
  Box as MuiBox,
  Stack,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

import EstimationColumns, {
  SummaryColumns,
  NozzleEstimationColumns,
  estCols,
  trimListCols,
  pvEstCols,
  pvSumEst,
  createSummaryColumns,
} from "./columns";
import { minimalMuiTableProps } from "../../../../../styles/muiProps";
import { useEffect, useState, useRef, useMemo } from "react";
import AddToFabricationDialog from "./AddToFabricationDialog";
import ValidateDialog from "./ValidateDialog";
import { transformsPVEstData } from "./utils";
import DataSource from "./DataSourceRadioButtons";
import { json } from "react-router-dom";
import RevisionModal from "./RevisionSavingModal";
import NewRACIModal from "./NewRACIModal";
import SharePointIcon from "../../../../../components/CustomIcons/SharePointIcon";
import { secondAxios } from "../../../../../api/axios";
import { useParams, useNavigate } from "react-router-dom";

// import { columns } from "../../CommonFeatures/EstimationTab/utils";

export default function EstimationTab({
  projectId,
  plant,
  parentTabIndex,
  parentType,
}) {
  // const { getValues } = useFormContext();

  const printRef = useRef();

  // const { DGV_Main_Estimation, Est_Sum_DGV, Fab_Rate_Txt, Proposal_Cost_Txt } =
  //   getValues();
  const [DGV_Main_Estimation, setDGV_Main_Estimation] = useState([]);
  const [Est_Sum_DGV, setEst_Sum_DGV] = useState([]);
  const [Fab_Rate_Txt, setFab_Rate_Txt] = useState("");
  const [Proposal_Cost_Txt, setProposal_Cost_Txt] = useState("");
  const [tableData, setTableData] = useState([]);
  const [estData, setEstData] = useState(undefined);
  const [dataSource, setDataSource] = useState("sharepoint");

  // console.log("est data", getValues());

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isValidateDialogOpen, setValidateDialog] = useState(false);
  const [isReviosnModalOpen, setRevisionModal] = useState(false);
  const [inputRevNum, setInpuRevNum] = useState(null);
  const { plantId } = useParams();
  const navigate = useNavigate();
const [totalSummaryData, setTotalSummaryData] = useState([]);
  // New state for project/revision selection
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedRevisionId, setSelectedRevisionId] = useState("");

  const getValuesAxios = async () => {
    console.log("getting data ", parentType);

    const res = await secondAxios.get(`/plant/${plantId}`);
    const plantData = res.data?.data || res.data; // handle { data: { ...plant }} shape
    const allProjects = Array.isArray(plantData?.projects)
      ? plantData.projects
      : Array.isArray(res.data.project)
      ? res.data.project
      : res.data.projects ||
        (res.data.project
          ? [res.data.project]
          : Array.isArray(res.data)
          ? res.data
          : [res.data]);
    console.log(
      "pppppp",
      allProjects.filter(
        (p) => p.clientName === process.env.REACT_APP_CLIENT_NAME
      )
    );
    const filteredProjects = allProjects.filter(
      (p) =>
        p.clientName === process.env.REACT_APP_CLIENT_NAME &&
        p.type === parentType
    );

    // Store projects for dropdown (no auto-loading)
    setProjects(filteredProjects);

    return filteredProjects[0];
  };

  // const loadSummaryData = async (projectList, selectedIndices) => {
  //   let combinedData = [];

  //   // If no projects selected, show all
  //   if (!Array.isArray(selectedIndices) || selectedIndices.length === 0) {
  //     projectList.forEach((project) => {
  //       const summary =
  //         project?.revisions?.[0]?.data?.estimationTable?.[0]?.Summary || [];

  //       if (summary?.length) {
  //         combinedData.push(
  //           ...summary.slice(0, Math.max(0, summary.length - 4))
  //         );
  //       }
  //     });
  //   } else {
  //     selectedIndices.forEach((idx) => {
  //       const project = projectList[idx];
  //       if (project) {
  //         const summary =
  //           project?.revisions?.[0]?.data?.estimationTable?.[0]?.Summary || [];
  //         // console.log("summaryxxx", summary);
  //         if (summary?.length) {
  //           combinedData.push(
  //             ...summary.slice(0, Math.max(0, summary.length - 4))
  //           );
  //         }
  //       }
  //     });
  //   }
  //   const materialRecords = await secondAxios.get("/material-record");
  //   const currentData = (combinedData || []).filter(
  //     (item) => item?.MaterialDescription
  //   );
  //   console.log({ materialRecords, currentData });
  //   const summaryData = currentData.map((item) => {
  //     const materialRecord = materialRecords?.data?.find((mr) =>
  //       mr.description.includes(item.MaterialDescription)
  //     );

  //     // console.log("materialRecord", materialRecord);

  //     return {
  //       ...item,
  //       unitCost: materialRecord?.estCost || "Not Added!",
  //     };
  //   });
  //   setTableData(summaryData);
  //   setEstData(summaryData);
  // };
  let fhGetValues;
  try {
    const ctx = useFormContext();
    fhGetValues = ctx?.getValues ?? (() => ({}));
  } catch (e) {
    // No form context available (e.g. when `plant` is true) — provide a safe fallback
    fhGetValues = () => ({});
  }
  const getValues = plant ? getValuesAxios : fhGetValues;

  const [assembly, setAssembly] = useState([]); // Changed to array for multi-select
  const [rev, setRev] = useState("");
  const [projects, setProjects] = useState([]);

  // Get available revisions for selected project
  const getAvailableRevisions = () => {
    if (!selectedProjectId || !projects.length) return [];
    const project = projects.find((p) => p.id === selectedProjectId);
    return project?.revisions || [];
  };

  // Check if data from selected project/revision is already in the table
  const isDataAlreadyAdded = () => {
    if (!selectedProjectId || !selectedRevisionId || !tableData.length)
      return false;
    return tableData.some(
      (row) =>
        row._projectId === selectedProjectId &&
        row._revisionId === selectedRevisionId
    );
  };

  // Handle adding selected project/revision Summary data to table
  const handleAddSummaryData = () => {
    if (!selectedProjectId || !selectedRevisionId || !projects.length) return;

    const project = projects.find((p) => p.id === selectedProjectId);
    if (!project) return;

    const revision = project.revisions?.find(
      (r) => r.id === selectedRevisionId
    );
    if (!revision?.data?.estimationTable) return;

    // estimationTable is an object with numeric string keys like "0", "1"
    const estimationTable = revision.data.estimationTable;
    if (!estimationTable || typeof estimationTable !== "object") return;

    const keys = Object.keys(estimationTable);
    if (keys.length === 0) return;

    const firstKey = keys[0];
    const summaryData = estimationTable[firstKey]?.Summary;
    const totalSummaryData = estimationTable[firstKey]?.totalSummary;

    if (Array.isArray(summaryData) && summaryData.length > 0) {
      // Filter out summary rows (rows with isSummary flag)
      const filteredSummary = summaryData.filter((row) => !row.isSummary);

      // Add metadata to track which project/revision this data came from
      const dataWithMetadata = filteredSummary.map((row) => ({
        ...row,
        _projectId: selectedProjectId,
        _revisionId: selectedRevisionId,
      }));

      // Append the new data to existing table data
      setTableData((prevData) => [...prevData, ...dataWithMetadata]);
      setEstData((prevData) => {
        const newData = prevData
          ? [...prevData, ...dataWithMetadata]
          : [...dataWithMetadata];
        return newData;
      });
    }

    // Extract and transform totalSummary data
    if (Array.isArray(totalSummaryData) && totalSummaryData.length > 0) {
      // Transform API data format to match column structure
      // API has: name, value, unit, rate, total
      // Columns expect: description, qty, unit, rate, total
      const transformedTotalSummary = totalSummaryData.map((item) => ({
        description: item.name || "",
        qty: item.value || "",
        unit: item.unit || "",
        rate: item.rate || "",
        total: item.total || "",
        _projectId: selectedProjectId,
        _revisionId: selectedRevisionId,
      }));

      // Update totalSummaryData state
      setTotalSummaryData((prevData) => {
        // Remove any existing data from the same project/revision
        const filtered = prevData.filter(
          (row) =>
            !(
              row._projectId === selectedProjectId &&
              row._revisionId === selectedRevisionId
            )
        );
        // Add new data
        return [...filtered, ...transformedTotalSummary];
      });

      // Update rate states from the totalSummary data
      transformedTotalSummary.forEach((item) => {
        if (item.description === "Total Man Hours" && item.rate) {
          setManHourRate(item.rate);
        } else if (item.description === "Galvanized Cost" && item.rate) {
          setGalvanizedRate(item.rate);
        } else if (item.description === "Painting Cost" && item.rate) {
          setPaintingRate(item.rate);
        } else if (item.description === "Fire Proof Cost" && item.rate) {
          setFireProofRate(item.rate);
        } else if (item.description === "Miscellaneous" && item.rate) {
          setMiscellaneousCost(item.rate);
        }
      });
    }

    // Reset selection after adding
    setSelectedProjectId("");
    setSelectedRevisionId("");
  };

  // Handle removing selected project/revision data from table
  const handleRemoveSummaryData = () => {
    if (!selectedProjectId || !selectedRevisionId) return;

    // Filter out rows that match the selected project/revision
    setTableData((prevData) =>
      prevData.filter(
        (row) =>
          !(
            row._projectId === selectedProjectId &&
            row._revisionId === selectedRevisionId
          )
      )
    );
    setEstData((prevData) =>
      prevData
        ? prevData.filter(
            (row) =>
              !(
                row._projectId === selectedProjectId &&
                row._revisionId === selectedRevisionId
              )
          )
        : []
    );
    // Remove corresponding totalSummaryData
    setTotalSummaryData((prevData) =>
      prevData.filter(
        (row) =>
          !(
            row._projectId === selectedProjectId &&
            row._revisionId === selectedRevisionId
          )
      )
    );
    // Reset selection after removing
    setSelectedProjectId("");
    setSelectedRevisionId("");
  };

  // Cost summary rates
  const [manHourRate, setManHourRate] = useState("");
  const [galvanizedRate, setGalvanizedRate] = useState("");
  const [paintingRate, setPaintingRate] = useState("");
  const [fireProofRate, setFireProofRate] = useState("");
  const [miscellaneousCost, setMiscellaneousCost] = useState("");
  // console.log("revssss", getValues());
  const revsData = plant
    ? []
    : getValues().revisions
    ? getValues().revisions.map((r) => r.data)
    : "";

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setValidateDialog(false);
    setIsDialogOpen(false);
  };
  const handleAssemblyChange = (e) => {
    setAssembly(e.target.value);
  };
  const handleRevChange = (e) => {
    // console.log("revision value", e.target.value);

    setRev(e.target.value);
  };

  // Create columns (non-editable)
  const summaryColumns = useMemo(() => {
    return createSummaryColumns(null, null, null);
  }, []);

  // useEffect(() => {
  //   const setEstData = () => {
  //     // console.log("revision", revsData[rev]);
  //     const data = revsData[rev];
  //     console.log(data);
  //     if (data) {
  //       setDGV_Main_Estimation(data.DGV_Main_Estimation);
  //       setEst_Sum_DGV(data.Est_Sum_DGV);
  //       setFab_Rate_Txt(data.Fab_Rate_Txt);
  //       setProposal_Cost_Txt(data.Proposal_Cost_Txt);
  //     }
  //   };
  //   setEstData();
  // }, [rev, revsData]);
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    // console.log("hhhhhhhhhhhhhhhhhhh", event);
    if (!file) return;

    try {
      const fileContent = await file.text();

      const jsonData = JSON.parse(fileContent);
      // console.log("jsonData", jsonData);
      setTableData(jsonData.data.DGV_Estimation_Est);
      setEstData(jsonData.data.DGV_Estimation_Est);
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };
  // Removed automatic data loading - data is now added manually via Add button
  // useEffect(() => {
  //   if (plant && projects.length > 0) {
  //     // loadSummaryData(projects, assembly);
  //   }
  // }, [assembly, plant, projects]);

  useEffect(() => {
    if (plant) {
      console.log("hereeee");

      getValues();
      return;
    }
    if (dataSource === "database") {
      console.log("fetching from database");
      const revs = getValues()?.revisions || [];
      const getData = () => {
        if (revs[0]) {
          const projData = revs[0]?.data;
          return typeof projData === "string" ? JSON.parse(projData) : projData;
        }
      };
      const data = getData();
      // console.log("hereeeee", data);
      console.log(
        "hereeeee",
        data?.data?.estimationTable[0].Summary ||
          data?.estimationTable[0].Summary
      );
      const summaryData =
        data?.data?.estimationTable[0].Summary ||
        data?.estimationTable[0].Summary;
      const totalSummaryData =
        data?.data?.estimationTable[0].totalSummary ||
        data?.estimationTable[0].totalSummary;

      setEstData(summaryData);
      setTableData(summaryData);

      // Transform and set totalSummaryData
      if (Array.isArray(totalSummaryData) && totalSummaryData.length > 0) {
        const transformedTotalSummary = totalSummaryData.map((item) => ({
          description: item.name || "",
          qty: item.value || "",
          unit: item.unit || "",
          rate: item.rate || "",
          total: item.total || "",
        }));
        setTotalSummaryData(transformedTotalSummary);

        // Update rate states from the totalSummary data
        transformedTotalSummary.forEach((item) => {
          if (item.description === "Total Man Hours" && item.rate) {
            setManHourRate(item.rate);
          } else if (item.description === "Galvanized Cost" && item.rate) {
            setGalvanizedRate(item.rate);
          } else if (item.description === "Painting Cost" && item.rate) {
            setPaintingRate(item.rate);
          } else if (item.description === "Fire Proof Cost" && item.rate) {
            setFireProofRate(item.rate);
          } else if (item.description === "Miscellaneous" && item.rate) {
            setMiscellaneousCost(item.rate);
          }
        });
      }
    }
  }, [dataSource, parentType, plant, plantId]);
  // useEffect(() => {
  //   console.log("est data", DGV_Main_Estimation);
  // }, [isDialogOpen]);

  // console.log("dddddd", data());

  // // const manhours = [
  // //   data()?.data?.DGV_Estimation_Est[0]["Total Manhour"],
  // //   data()?.data?.DGV_Estimation_Est[1]["Total Manhour"],
  // //   data()?.data?.DGV_Estimation_Est[2]["Total Manhour"],
  // //   "",
  // //   4.9,
  // //   1.55,
  // //   4.95,
  // //   1.8,
  // //   1.55,
  // //   1.55,
  // //   1.55,
  // //   10.65,
  // // ];
  // // const weights = data()?.data?.DGV_Est_BOM.map((row) => row["Total Weight"]);
  // // const pvEstData = [
  // //   ...data()?.data?.DGV_Shell_BOM,
  // //   ...data()?.data?.DGV_Nozzle_Material_Description,
  // // ]
  // //   .map((row, i) => {
  // //     const Components = row.Description || row["Material Description"] || "";
  // //     const weight = row["Total Weight"] || "";
  // //     const cost = row["Cost (US $)"] || row["Total Cost (US $)"];

  // //     return {
  // //       ...row,
  // //       Components,
  // //       // "Total Weight (Kg)": weight,
  // //       "Total Material Cost (US $)": cost,
  // //       "Total Manhour": manhours[i],
  // //       "Total Weight (Kg)": weights[i],
  // //       Unit: row.Unit ? row.Unit : "No.",
  // //     };
  // //   })
  // //   .filter((row) => row.Components !== "Total");

  // Calculate cost summary from filtered data
  const calculateCostSummary = useMemo(() => {
    if (!tableData || tableData.length === 0) {
      return {
        totalMaterialsCost: 0,
        totalManHours: 0,
        galvanizedQty: 0,
        paintingQty: 0,
        fireProofQty: 0,
      };
    }

    let totalMaterialsCost = 0;
    let totalManHours = 0;
    let galvanizedQty = 0;
    let paintingQty = 0;
    let fireProofQty = 0;

    tableData.forEach((row) => {
      // Total Materials Cost - calculate from procuredQty * unitCost or use existing totalCost
      const materialCost =
        row.procuredQty && row.unitCost && row.unitCost !== "Not Added!"
          ? Number(row.procuredQty) * Number(row.unitCost)
          : parseFloat(
              row.totalCost ||
                row.MaterialCost ||
                row["Total Material Cost (US $)"] ||
                0
            );
      totalMaterialsCost += isNaN(materialCost) ? 0 : materialCost;

      // Total Man Hours
      const fabHrs = parseFloat(row.totalFabHrs || row["Total Fab (hrs)"] || 0);
      totalManHours += isNaN(fabHrs) ? 0 : fabHrs;

      // Galvanized, Painting, Fire Proof quantities (if available in data)
      // These might need to be adjusted based on actual data structure
      if (row.Galvanized) {
        const qty = parseFloat(row.Qty || 0);
        galvanizedQty += isNaN(qty) ? 0 : qty;
      }
      if (row.Painted || row.Painting) {
        const qty = parseFloat(row.Qty || 0);
        paintingQty += isNaN(qty) ? 0 : qty;
      }
      if (row.FireProofed || row["Fire Proof"]) {
        const qty = parseFloat(row.Qty || 0);
        fireProofQty += isNaN(qty) ? 0 : qty;
      }
    });

    return {
      totalMaterialsCost,
      totalManHours,
      galvanizedQty,
      paintingQty,
      fireProofQty,
    };
  }, [tableData]);

  // Transform summary data to fabrication format
  const transformSummaryToFabrication = (summaryData) => {
    return summaryData
      .filter((row) => !row.isSummary && row.MaterialDescription) // Filter out summary rows
      .map((row) => ({
        "Cost Code": "Structure", // Default cost code
        Components: row.MaterialDescription || row.Components || "",
        Qty: Number(row.Qty || row.quantity || row.length || 1),
        "Total Manhour": Number(row.totalFabHrs || row["Total Manhour"] || row.estimatedHours || 0),
        MaterialDescription: row.MaterialDescription || row.Components || "",
        scope: row.scope || row.Scope || "",
        // Keep original data for reference
        _originalData: row,
      }));
  };

  // Calculate totals for cost summary
  const manHoursTotal = useMemo(() => {
    const rate = parseFloat(manHourRate) || 0;
    return calculateCostSummary.totalManHours * rate;
  }, [manHourRate, calculateCostSummary.totalManHours]);

  const galvanizedTotal = useMemo(() => {
    const rate = parseFloat(galvanizedRate) || 0;
    return calculateCostSummary.galvanizedQty * rate;
  }, [galvanizedRate, calculateCostSummary.galvanizedQty]);

  const paintingTotal = useMemo(() => {
    const rate = parseFloat(paintingRate) || 0;
    return calculateCostSummary.paintingQty * rate;
  }, [paintingRate, calculateCostSummary.paintingQty]);

  const fireProofTotal = useMemo(() => {
    const rate = parseFloat(fireProofRate) || 0;
    return calculateCostSummary.fireProofQty * rate;
  }, [fireProofRate, calculateCostSummary.fireProofQty]);

  const miscellaneousTotal = parseFloat(miscellaneousCost) || 0;

  const totalProjectCost = useMemo(() => {
    // Sum the total values from totalSummaryData if available
    if (totalSummaryData && totalSummaryData.length > 0) {
      return totalSummaryData.reduce((sum, row) => {
        const total = parseFloat(row.total) || 0;
        return sum + total;
      }, 0);
    }
    // Fallback to calculated values if totalSummaryData is not available
    return (
      calculateCostSummary.totalMaterialsCost +
      manHoursTotal +
      galvanizedTotal +
      paintingTotal +
      fireProofTotal +
      miscellaneousTotal
    );
  }, [
    totalSummaryData,
    calculateCostSummary.totalMaterialsCost,
    manHoursTotal,
    galvanizedTotal,
    paintingTotal,
    fireProofTotal,
    miscellaneousTotal,
  ]);

  // Cost summary table data
  // const costSummaryData = [
  //   {
  //     description: "Total Materials Cost",
  //     qty: "",
  //     unit: "$",
  //     rate: "-",
  //     total: calculateCostSummary.totalMaterialsCost.toFixed(2),
  //   },
  //   {
  //     description: "Total Man Hours",
  //     qty: calculateCostSummary.totalManHours.toFixed(2),
  //     unit: "hr",
  //     rate: manHourRate,
  //     total: manHoursTotal.toFixed(2),
  //   },
  //   {
  //     description: "Galvanized Cost",
  //     qty: calculateCostSummary.galvanizedQty.toFixed(2),
  //     unit: "Ft²",
  //     rate: galvanizedRate,
  //     total: galvanizedTotal.toFixed(2),
  //   },
  //   {
  //     description: "Painting Cost",
  //     qty: calculateCostSummary.paintingQty.toFixed(2),
  //     unit: "Ft²",
  //     rate: paintingRate,
  //     total: paintingTotal.toFixed(2),
  //   },
  //   {
  //     description: "Fire Proof Cost",
  //     qty: calculateCostSummary.fireProofQty.toFixed(2),
  //     unit: "Ft²",
  //     rate: fireProofRate,
  //     total: fireProofTotal.toFixed(2),
  //   },
  //   {
  //     description: "Miscellaneous",
  //     qty: "",
  //     unit: "LS",
  //     rate: miscellaneousCost,
  //     total: miscellaneousTotal.toFixed(2),
  //   },
  // ];

  // Cost summary columns
  const costSummaryColumns = [
    {
      accessorKey: "description",
      header: "",
      size: 150,
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "qty",
      header: "Qty",
      size: 80,
      enableSorting: false,
      enableHiding: false,
      muiTableBodyCellProps: { align: "right" },
    },
    {
      accessorKey: "unit",
      header: "Unit",
      size: 60,
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "rate",
      header: "Rate ($)/ Unit",
      size: 120,
      enableSorting: false,
      enableHiding: false,
      Cell: ({ row, cell }) => {
        const value = cell.getValue();
        return (
          <Typography sx={{ fontSize: "0.875rem", color: "#666" }}>
            {value || ""}
          </Typography>
        );
      },
    },
    {
      accessorKey: "total",
      header: "Total $",
      size: 100,
      enableSorting: false,
      enableHiding: false,
      muiTableBodyCellProps: { align: "right" },
      Cell: ({ cell }) => {
        const value = parseFloat(cell.getValue()) || 0;
        return value.toFixed(2);
      },
    },
  ];

  // const pvEstData = transformsPVEstData(data());
  const handlePrinting = () => {};
  return (
    <Box>
      {plant && (
        <Stack
          direction={"row"}
          padding={2}
          spacing={2}
          sx={{ alignItems: "center", flexWrap: "wrap" }}
        >
          <FilterListIcon color="secondary" />
          <Typography variant="h6" color="darkBlue">
            Add Summary Data:
          </Typography>
          <FormControl sx={{ minWidth: 250 }}>
            <InputLabel id="project-select-label">Project</InputLabel>
            <Select
              labelId="project-select-label"
              id="project-select"
              value={selectedProjectId}
              label="Project"
              onChange={(e) => {
                setSelectedProjectId(e.target.value);
                setSelectedRevisionId(""); // Reset revision when project changes
              }}
            >
              {(projects || []).map((p) => (
                <MenuItem value={p.id} key={p.id}>
                  {p.name || p.title || `Project ${p.id}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="revision-select-label">Revision</InputLabel>
            <Select
              labelId="revision-select-label"
              id="revision-select"
              value={selectedRevisionId}
              label="Revision"
              onChange={(e) => setSelectedRevisionId(e.target.value)}
              disabled={!selectedProjectId}
            >
              {getAvailableRevisions().map((rev) => (
                <MenuItem value={rev.id} key={rev.id}>
                  {rev.name || `Revision ${rev.id}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color={isDataAlreadyAdded() ? "error" : "primary"}
            onClick={
              isDataAlreadyAdded()
                ? handleRemoveSummaryData
                : handleAddSummaryData
            }
            disabled={!selectedProjectId || !selectedRevisionId}
            sx={{ minWidth: 100 }}
          >
            {isDataAlreadyAdded() ? "Remove" : "Add"}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => navigate(`/plant/${plantId}/pcs`)}
            sx={{ minWidth: 120, ml: 2 }}
          >
            Go to PCS
          </Button>
        </Stack>
      )}
      <Box sx={{ p: 1, width: "80%" }}>
        <Table
          // columns={EstimationColumns()}
          columns={summaryColumns}
          // columns={estCols}
          // data={
          //   assembly == 1 && rev !== "" && DGV_Main_Estimation
          //     ? DGV_Main_Estimation
          //     : []
          // }
          // data={data()?.Estimation_DGV || []}
          data={tableData}
          additionalProps={{
            renderTopToolbarCustomActions: () => (
              <Box
                sx={{ minWidth: 500, display: "flex", alignItems: "center" }}
              >
                {!plant && (
                  <>
                    <DataSource setSource={setDataSource} source={dataSource} />

                    {dataSource === "sharepoint" && (
                      <Button
                        variant="outlined"
                        component="label"
                        sx={{
                          mt: 2.5,
                          mr: 1,
                          mb: 2,
                          transform: "translateY(-2px)",
                        }}
                        startIcon={<SharePointIcon size={23} />}
                        // onClick={onSelectFromSharepoint}
                      >
                        Browse
                        <input
                          // id="upload-button"
                          type="file"
                          hidden
                          onChange={handleFileChange}
                        />
                      </Button>
                    )}

                    {/* <Button
                      variant="contained"
                      color="primary"
                      onClick={handleDialogOpen}
                      sx={{ minWidth: 150, mx: 0.8 }}
                      disabled={!estData?.length}
                    >
                      Add to Fabrication
                    </Button> */}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setValidateDialog(true);
                      }}
                      sx={{ minWidth: 150, mx: 0.8 }}
                      disabled={!estData?.length}
                    >
                      Validate
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => printRef.current.generatePDF()}
                      sx={{ minWidth: 150, mx: 0.8 }}
                      disabled={!estData?.length}
                    >
                      Print to PDF
                    </Button>
                  </>
                )}
                {/* {plant && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDialogOpen}
                    sx={{ minWidth: 150, mx: 0.8 }}
                    disabled={!tableData?.length}
                  >
                    Add to Fabrication
                  </Button>
                )} */}
                {/* <input
                  type="file"
                  accept=".json"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  id="file-input"
                />
                <label htmlFor="file-input">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{ marginRight: 2 }}
                    disabled={dataSource !== "sharepoint"}
                  >
                    Browse
                  </Button>
                </label> */}

                {/* <FormControl sx={{ minWidth: 200, marginRight: 1 }}>
                <InputLabel id="assembly-label">Assembly</InputLabel>
                <Select
                  labelId="assembly-label"
                  id="assembly-select"
                  value={assembly}
                  label="Assembly"
                  onChange={handleAssemblyChange}
                >
                  <MenuItem value={1}>Base Proposal</MenuItem>
                  <MenuItem value={2}>Change order1</MenuItem>
                  <MenuItem value={3}>Change order2</MenuItem>
                  {/* <MenuItem value={20}>Twenty</MenuItem>
    <MenuItem value={30}>Thirty</MenuItem> 
                </Select>
              </FormControl> */}
                {/* <FormControl sx={{ minWidth: 200 }}>
                <InputLabel id="rev-label">Rev</InputLabel>
                <Select
                labelId="rev-label"
                  id="rev-select"
                  value={rev}
                  label="Rev"
                  onChange={handleRevChange}
                >
                  {revNums.map((r, index) => (
                    <MenuItem value={index}>{r}</MenuItem>
                  ))}
                  {/* <MenuItem value={1}>0</MenuItem>
                  <MenuItem value={2}>1</MenuItem>
                  <MenuItem value={3}>2</MenuItem> */}
                {/* <MenuItem value={20}>Twenty</MenuItem>
    <MenuItem value={30}>Thirty</MenuItem> 
                </Select>
              </FormControl> */}
              </Box>
            ),
            initialState: {
              pagination: { pageSize: 50, pageIndex: 0 },
            },
          }}
        />
      </Box>

      {/* Cost Summary Table */}
      <Box sx={{ p: 2, width: "50%", maxWidth: "600px" }}>
        <Typography
          variant="h6"
          sx={{ mb: 1, fontWeight: "bold", fontSize: "1.1rem" }}
        >
          Total Cost Summary:
        </Typography>
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            overflow: "hidden",
            backgroundColor: "white",
          }}
        >
          <Table
            columns={costSummaryColumns}
            data={totalSummaryData}
            additionalProps={{
              enableTopToolbar: false,
              enableBottomToolbar: false,
              enablePagination: false,
              enableColumnActions: false,
              enableSorting: false,
              enableFilters: false,
              enableFullScreenToggle: false,
              enableDensityToggle: false,
              initialState: {
                density: "compact",
              },
              muiTableBodyCellProps: {
                sx: {
                  padding: "10px 16px",
                  borderBottom: "1px solid #e0e0e0",
                  backgroundColor: "white",
                  fontSize: "0.875rem",
                },
              },
              muiTableHeadCellProps: {
                sx: {
                  padding: "10px 16px",
                  backgroundColor: "#f5f5f5",
                  fontWeight: "bold",
                  borderBottom: "2px solid #e0e0e0",
                  color: "#333",
                  fontSize: "0.875rem",
                },
              },
              muiTableContainerProps: {
                sx: {
                  backgroundColor: "white",
                },
              },
            }}
          />
        </Paper>
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
            textAlign: "right",
            border: "1px solid #e0e0e0",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", fontSize: "1rem", color: "#333" }}
          >
            Total Project Cost = {totalProjectCost.toFixed(2)}
          </Typography>
        </Box>
      </Box>

      {/* <Grid container sx={{ pl: 1 }}>
        <Grid Item xs={6}>
          <Box sx={{ my: 2 }}>
            <Typography
              sx={{ background: "white", py: 1, px: 2, lineHeight: 2 }}
            >
              {" "}
              Engg. and PM Percentage
              <TextField
                sx={{ "& input": { p: 0.5, width: 30 }, mx: 0.5 }}
                value={estData?.data.TextBox6}
              />{" "}
              %
            </Typography>
            <Table
              columns={pvSumEst}
              data={estData?.data.DGV_Estimation_Extra || []}
            />
          </Box>
        </Grid>
      </Grid> */}
      {/* <Grid container spacing={2}>
        <Grid item xs={6} sx={{ my: 1 }}>
          <Table
            columns={trimListCols}
            data={data()?.EstimationSummaryDescription_DGV || []}
          />
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ my: 1, borderRadius: "5px" }}>
            <Grid
              container
              sx={{
                // backgroundColor: "#fff",
                p: 5.4,
                "& > *": { p: 1, fontWeight: "bold" },
              }}
            >
              <Grid item xs={6}>
                Component Total Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtComponentsTotalCost || ""}
                </Grid>

              <Grid item xs={6}>
                Fabrication Labour Total Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtFabricationLabourTotalCost || ""}
              </Grid>

              <Grid item xs={6}>
                Engineering Design Total and Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtEngineeringDesignTotalCost || ""}
              </Grid>

              <Grid item xs={6}>
                Testing and Shipping Total Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtTestingAndShippingTotalCost || ""}
              </Grid>

              <Grid item xs={6}>
                Total Components nd Labour Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtTotalComponentsAndLabourCost || ""}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid> */}

      {/* Add to Fabrication Dialog */}
      <AddToFabricationDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        data={plant ? transformSummaryToFabrication(tableData) : tableData}
        plant={plant}
        plantId={plantId}
      />
      <ValidateDialog
        open={isValidateDialogOpen}
        onClose={handleDialogClose}
        data={revsData || []}
      />

      {/* Summary Box */}
      {/*   <Stack direction={"row"} gap={1}>
        <Box
        sx={{ backgroundColor: "white", borderRadius: "5px" }}
          mt={5}
          width={"50%"}
          p={2}
          >
          <Stack pb={1} direction={"row"} alignItems={"center"}>
            <Typography>Fabrication Rate</Typography>
            
            <TextField
            sx={{ paddingLeft: 3, paddingRight: 3 }}
              id="fab-rate"
              value={
                assembly == 1 && rev !== "" && Fab_Rate_Txt ? Fab_Rate_Txt : ""
              }
              // label="Fabrication Rate"
              variant="outlined"
              size="small"
              contentEditable={false}
            />
            <Typography>$/hr</Typography>
          </Stack>
          <Table
            columns={SummaryColumns()}
            data={
              assembly == 1 && rev !== "" && reformatSummaryTable
                ? reformatSummaryTable
                : []
            }
            additionalProps={{
              ...minimalMuiTableProps,
              enableTopToolbar: false,
              enableBottomToolbar: false,
            }}
          />
          <Stack pt={1} direction={"row"} alignItems={"center"}>
            <Typography>Proposal Cost</Typography>

            <TextField
              sx={{ paddingLeft: 3, paddingRight: 3 }}
              id="prop-cost"
              size="small"
              value={
                assembly == 1 && Proposal_Cost_Txt ? Proposal_Cost_Txt : ""
              }
              // label="Proposal Cost"
              variant="outlined"
              contentEditable={false}
              disabled={true}
            />
            <Typography>$</Typography>
          </Stack>
        </Box> */}
      {/* <Stack
          // justifyContent={"center"}
          // alignItems={"center"}
          sx={{ backgroundColor: "white" }}
          mt={5}
          width={"50%"}
        >
          <Typography variant="h4" alignSelf={"center"}>
            Nozzle Estimation Data
          </Typography>
          <Table columns={NozzleEstimationColumns()} data={[]} />
        </Stack> 
      </Stack>*/}
      <PrintToPDF
        ref={printRef}
        header="Estimation Data"
        revNUm={inputRevNum}
        type="Estimation"
        folderPath="PV-CDT-001/2. Estimation/"
        tableComponent={
          <Table
            columns={pvEstCols}
            data={tableData}
            additionalProps={{
              enableTopToolbar: false,
              enableBottomToolbar: false,
              enablePagination: false,
              enableColumnActions: false,
              enableSorting: false,
              enableFilters: false,
              enableFullScreenToggle: false,
              enableDensityToggle: false,
              initialState: {
                pagination: { pageSize: 50, pageIndex: 0 },
              },
            }}
          />
        }
      />
      {/* <RevisionModal
        open={isReviosnModalOpen}
        onClose={() => {
          setRevisionModal(false);
        }}
        onSubmit={(revision) => {
          setInpuRevNum(revision);
          printRef.current.generatePDF();
          console.log("Revision submitted:", revision);
        }}
      /> */}
      {/* <NewRACIModal
        open={isReviosnModalOpen}
        handleClose={() => {
          setRevisionModal(false);
        }}
        handleAddRow={(data) => {
          console.log("Data from NewRACIModal:", data);
          // Handle the data as needed
        }}
        allUsers={[]}
        type={"Estimation"}
      /> */}
    </Box>
  );
}
